import { render, staticRenderFns } from "./taskSkillTabs.vue?vue&type=template&id=fdc36c82&scoped=true&"
import script from "./taskSkillTabs.vue?vue&type=script&lang=js&"
export * from "./taskSkillTabs.vue?vue&type=script&lang=js&"
import style0 from "./taskSkillTabs.vue?vue&type=style&index=0&id=fdc36c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc36c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc36c82')) {
      api.createRecord('fdc36c82', component.options)
    } else {
      api.reload('fdc36c82', component.options)
    }
    module.hot.accept("./taskSkillTabs.vue?vue&type=template&id=fdc36c82&scoped=true&", function () {
      api.rerender('fdc36c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/taskSkillTabs.vue"
export default component.exports